import {HiOutlineMail} from 'react-icons/hi'
import {RiMessengerLine} from 'react-icons/ri'
import {FaWhatsapp} from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:mouinbkr@gmail.com'},
    {id: 2, icon: <RiMessengerLine/>, link: 'https://www.facebook.com/mouin.boubakri.75'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+21650588372'}
]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546


export default data